import { Link } from 'react-router-dom';
import type { AccountInfo } from '@/shared/services/accountService';

export function AccountStrip({ account, tags }: { account: AccountInfo; tags: string[] }) {
  return (
    <section className="account-strip panel-surface">
      <div className="account-strip-bg"></div>
      <div className="account-main">
        <div className="account-icon">♙</div>
        <div>
          <span className="eyebrow">Conta ativa</span>
          <h2>{account.userName || account.id} {account.isGM && <small>GM</small>}</h2>
          <p>
            {account.email || 'Sem email cadastrado'} · <b>{account.isCellphoneVerified ? 'Verificado' : 'Não verificado'}</b>
          </p>
          <div className="account-tags">{tags.map((t) => <span key={t}>{t}</span>)}</div>
        </div>
      </div>
      <div className="account-actions">
        <Link to="/dashboard/conta">Gerenciar conta</Link>
        <Link to="/dashboard/recarga">Recarregar</Link>
        <Link to="/dashboard/personagens">Ver personagens</Link>
      </div>
    </section>
  );
}
